var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0003 30.3332C8.09366 30.3332 1.66699 23.9065 1.66699 15.9998C1.66699 8.09317 8.09366 1.6665 16.0003 1.6665C23.907 1.6665 30.3337 8.09317 30.3337 15.9998C30.3337 23.9065 23.907 30.3332 16.0003 30.3332ZM16.0003 3.6665C9.20033 3.6665 3.66699 9.19984 3.66699 15.9998C3.66699 22.7998 9.20033 28.3332 16.0003 28.3332C22.8003 28.3332 28.3337 22.7998 28.3337 15.9998C28.3337 9.19984 22.8003 3.6665 16.0003 3.6665Z",
    fill: "#DFDFE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2271 20.7733C11.9738 20.7733 11.7205 20.68 11.5205 20.48C11.1338 20.0933 11.1338 19.4533 11.5205 19.0666L19.0671 11.52C19.4538 11.1333 20.0938 11.1333 20.4805 11.52C20.8671 11.9066 20.8671 12.5466 20.4805 12.9333L12.9338 20.48C12.7471 20.68 12.4805 20.7733 12.2271 20.7733Z",
    fill: "#B5B8C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7738 20.7733C19.5205 20.7733 19.2671 20.68 19.0671 20.48L11.5205 12.9333C11.1338 12.5466 11.1338 11.9066 11.5205 11.52C11.9071 11.1333 12.5471 11.1333 12.9338 11.52L20.4805 19.0666C20.8671 19.4533 20.8671 20.0933 20.4805 20.48C20.2805 20.68 20.0271 20.7733 19.7738 20.7733Z",
    fill: "#B5B8C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.9802cc34b3440065f5f0d055397e4f7c.svg";
export { ForwardRef as ReactComponent };